import { useDispatch } from 'react-redux';
import { setUserReportModal } from '../../../reduxToolkit/slices/commonSlice';

export function useReportUser() {
  const dispatch = useDispatch();

  function showReportModal(userId: string, userName: string, messageId?: string) {
    dispatch(setUserReportModal({ userid: userId, userName, messageId }));
  }

  return { showReportModal };
}
